<template lang="pug">
.dawn-title-nav
  .container
    .row
      .col-md-12
        .title-area
          h1.page-title {{ title }}
          p.page-subtitle(v-if='subtitle') {{ subtitle }}
        .action-area.text-right(v-if='hasAction')
          slot(name='action')
</template>

<script>

export default {
  name: 'ed-title-nav',
  props: {
    title: String,
    subtitle: String
  },
  data () {
    return {
      backButton: false
    }
  },
  methods: {
    navigateBack () {
      // function to go back a page
    }
  },
  computed: {
    hasAction() {
      return this.$slots.action
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.dawn-title-nav {
  width: 100%;
  border-bottom: $border-default;
  border-color: $background-light;
  background: $canvas;
  text-transform: none;
  padding: .75rem $side-padding - .2rem .3rem;
  //position: absolute;
  //left: 0;

  .title-area, .action-area {
    display: inline-block;
  }

  .action-area {
    float: right;
    text-transform: uppercase;
    font-size: $font-size-xsmall;
    font-weight: $font-weight-bold;
    line-height: 3;

    i {
      margin-right: .5rem;
    }

    a {
      color: $ink;

      &:hover {
        text-decoration: none;
          color: $border;
      }
    }
  }

  h1.page-title {
    margin: 0;
    color: $border;
    font-size: $font-size-xxlarge;
    font-weight: $font-weight-normal;
    font-family: $font-family-sans-serif;
  }

  p.page-subtitle {
    font-size: $font-size-base;
    font-weight: $font-weight-bold;
  }
}

</style>



// WEBPACK FOOTER //
// index.vue?9c989f62